<template>
  <step-item-wrapper @stepManagerState="setFrom">
    <div class="step-manager-form-feature-1">
      <div class="row">
        <div class="col-lg-9 step-manager-form-feature-1-lg-9">
          <div class="container-fluid">
            <div v-for="(featureGroup,group) in sortedFeatures">

              <div class="row justify-content-center align-items-center"
                   v-if="product.props.showCategoryCollapseButton">
                <button type="button" class="btn btn-primary w-100 p-2 col-lg-11 my-3" data-toggle="collapse"
                        :data-target="'#feature-group-' + convertGroupNameUsableForCollapse(group)">
                  {{ group }}
                </button>
                <i class="bi bi-pen-fill col-lg-1" data-toggle="modal"
                   :data-target="'#feature-category-' + convertGroupNameUsableForCollapse(group)"></i>
                <div class="modal" :key="generateRandomString()"
                     :id="'feature-category-' + convertGroupNameUsableForCollapse(group)">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <h5 class="text-left">{{ group }}</h5>
                      </div>
                      <div class="modal-body text-right">
                        <m-feature-category-manager @changeCategories="refreshComponent" :product="product"
                                                    :feature-category="group"></m-feature-category-manager>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="collapse" :class="{'show':product.props.openFeatureCategories}"
                   :id="'feature-group-' + convertGroupNameUsableForCollapse(group)">
                <div v-for="feature in featureGroup" :key="generateRandomString()">
                  <m-product-feature-item :stepListFeatureComponent="stepListFeatureComponent" :listFeatureComponent="listFeatureComponent" :product="product" :productFeature="feature"></m-product-feature-item>
                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="col-lg-3" v-if="chooseFeature">
          <m-feature-search1 @selectedFeature="addFeature"/>
        </div>
      </div>
    </div>
  </step-item-wrapper>
</template>

<script>
import StepItemWrapper from "../../../../StepItemWrapper.vue";
import mFeatureSearch1 from "../Components/FeatureSearch/FeatureSearch1.vue";
import mProductFeatureItem from "../Components/ProductFeatureItem.vue";
import mFeatureCategoryManager from "../Components/FeatureCategoryManager.vue";

import {
  addFeatureToProduct,
  featureCategories, groupByType,
  removeChildFeature, removeEmptyGroups, sortedFeaturesMethod
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {baseFeature} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {generateRandomString} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: 'StepManagerFormFeature1',
  components: {mFeatureSearch1, StepItemWrapper, mProductFeatureItem, mFeatureCategoryManager},
  props: {
    chooseFeature: {
      type: Boolean,
      default: true,
    },
    stepListFeatureComponent: {
      default: 'feature-input-list-step',
    },
    listFeatureComponent:{
      default: 'feature-input-list',
    }
  },
  data() {
    return {
      baseFeature,
      product: {},
      sortedFeatures: {}
    };
  },
  computed: {},
  methods: {
    removeChildFeature,
    generateRandomString,
    addFeatureToProduct,
    addFeature(feature) {
      this.addFeatureToProduct(feature, this.product)
      toast("با موفقیت اضافه شد", "با موفقیت اضافه شد")
    },
    convertGroupNameUsableForCollapse(group) {
      return group.replaceAll(' ', '-')
    },
    refreshComponent() {
      this.$forceUpdate()
    },
    setFrom(value) {
      this.product = value
    },
    featureCategories,
    groupByType,
    removeEmptyGroups,
    sortedFeaturesMethod,
  },
  watch: {
    product: {
      handler(newValue, oldValue) {
        this.sortedFeatures = this.sortedFeaturesMethod(newValue.features)
      },
      deep: true
    }
  }
}
</script>


<style scoped>

</style>